import type { FaireProductEntity } from "../../entity_types/product";

export const p_uy7u9yrbtv: FaireProductEntity = {
  token: "p_uy7u9yrbtv",
  type: "product",
  name: "Fig Candle",
  brandToken: "b_fyb6rnmnyf",
  brandName: "Putnam Design LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/ffe3703aead7885c5af4b11960e79778f9146cdef4736fe21b21237fe74a8d16.jpeg",
  galleryImageUrls: [],
  priceDollars: 20,
  description:
    "Single note scented candle hand-poured and crafted in Los Angeles exclusively by Putnam Design\n\n9 oz of Soy wax\n40 hour burn time\nTrim wick before each use",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:14.312Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
